import "react-select/dist/react-select.css"
import React from "react"
import PropTypes from "prop-types"
import ReactSelect from "react-select"
import { omit } from "utils"
import { CrossIcon } from "components"
import classNames from "./select-base.css"

const Chevron = ({ style }) => (
  <svg style={style} viewBox="0 0 20 20">
    <path d="M0 5.8l1.6-1.6 8.4 8.4 8.4-8.4L20 5.8l-10 10-10-10z" />
  </svg>
)

const renderControl = Svg => () => (
  <div style={{ width: "0.85em", height: "0.85em", marginLeft: "auto" }}>
    <Svg style={{ fill: "#aaa", width: "100%", height: "100%" }} />
  </div>
)

const SelectBase = (props) => {
  const selectProps = {
    arrowRenderer: renderControl(Chevron),
    clearRenderer: renderControl(CrossIcon),
    ...omit(["style", "className"], props)
  }

  return (
    <div
      className={[classNames.__SelectBase].concat(props.className || []).join(" ")}
      style={{ ...props.style }}
      ref={props.getRef}>
      <ReactSelect {...selectProps} />
    </div>
  )
}

SelectBase.propTypes = {
  arrowRenderer: PropTypes.func,
  clearRenderer: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
}

SelectBase.defaultProps = {
  style: {}
}

export default SelectBase



// WEBPACK FOOTER //
// ./src/components/form-elements/select-base/koala.jsx